"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasourceTypeToJSON = exports.DatasourceTypeFromJSONTyped = exports.DatasourceTypeFromJSON = exports.DatasourceType = void 0;
/**
 * Type of datasource that diagnostic data is using.
 * @export
 */
exports.DatasourceType = {
    Pixel: 'PIXEL',
    Capi: 'CAPI'
};
function DatasourceTypeFromJSON(json) {
    return DatasourceTypeFromJSONTyped(json, false);
}
exports.DatasourceTypeFromJSON = DatasourceTypeFromJSON;
function DatasourceTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.DatasourceTypeFromJSONTyped = DatasourceTypeFromJSONTyped;
function DatasourceTypeToJSON(value) {
    return value;
}
exports.DatasourceTypeToJSON = DatasourceTypeToJSON;
